// ** Next imports

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { FaqTemplate, FaqH, FaqP } from "../../components/support/faqPages";
import { CONTACT_INFO } from "../../helpers/DATA";

const CancelService = () => (
  <Layout>
    <SEOHead title="Cancel Service" />
    <FaqTemplate title="Cancel Service">
      <FaqH>How do I cancel my service?</FaqH>
      <FaqP>
        We&#8217;re sorry to see any customer go, but we understand that things
        change and you may need to cancel your service. We make the process easy
        and painless! To cancel your service just send us a text message to{" "}
        {CONTACT_INFO.sms.text} or fill out the form below and let us know when
        you&#8217;d like to end your service.
      </FaqP>

      <FaqH>What happens after I cancel?</FaqH>
      <FaqP>
        Your service will be submitted for cancellation to our Billing
        Department to stop charges. We do not refund completed payments, so if
        you cancel service in the middle of a billing cycle you will not receive
        any pro-rated refund.
      </FaqP>
      <FaqP>
        We also submit a service termination to our Engineering Department, who
        will either turn off your service immediately or on the date you
        requested if you asked for a future cancellation. Your service may not
        stop immediately and it may take up to two business days for your
        service to stop operating correctly. You will not be billed for any
        service after your cancellation request.
      </FaqP>
    </FaqTemplate>
  </Layout>
);

export default CancelService;
